/**
 * TTS通用常量
 */
// 播放状态
export const TTS_STATUS={
    IDLE:"idle",          // 空闲
    PLAYING:"playing",    // 播放中
    STOPPED:"stopped"     // 已停止
};

// 音频格式
export const AUDIO_FORMAT={
    PCM:"pcm",            // 原始PCM
    WAV:"wav"             // WAV封装
};

// 默认音频配置
export const AUDIO_CONFIG={
    SAMPLE_RATE:16000,    // 默认采样率
    CHANNELS:1,           // 单声道
    BIT_DEPTH:16           // 位深
};

// 文本切割符号
export const DEFAULT_PUNCTUATION=[
    "。",
    "！",
    "？",
    "，",
    "、",
    "；",
    "：",
    "\n",
    "!",
    "?",
    ".",
    ",",
    ";",
    ":"
];